<template>
  <div id="box">
    <a-card style="box-sizing: border-box; border-radius: 0 !important">
      <!-- 未配置支付方式提示框 -->
      <a-divider v-if="!appId">请选择应用APPID</a-divider>
      <a-divider v-else-if="noConfigText">您尚未配置任何支付方式</a-divider>
      <!--      <a-divider v-else></a-divider>-->

      <!-- 支付测试面板 v-if=""-->
      <div v-if="payTestShow()" class="paydemo" style="width: 100%">

        <Header></Header>

        <div style="height: 80px"></div>

        <div class="paydemo-type-content" >
          <a-form-model
              ref="form"
              :label-col="{ span: 5 }"
              :model="form"
              :rules="rules"
              :wrapper-col="{ span: 18 }"
              @submit="handleSubmit"
          >
            <a-row>
              <a-col :span="1"><div style="width: 100%;height: 1px;"></div></a-col>
              <a-col :span="11">
                <a-form-model-item label="购买项目">
                  <el-tooltip class="item" effect="dark" content="该项目购买完成，直接使用邮箱发送链接处理即可。" placement="top">
                    <el-radio  border v-model="form.saletype" label="auto">{{ tobonumber.title }} <b style="color:red;">￥{{ tobonumber.price }}</b></el-radio>
                  </el-tooltip>

<!--                  <el-tooltip class="item" effect="dark" content="该项目购买完成，需要联系客服发送图片以及公司名称。" placement="top">-->
<!--                    <el-radio  border v-model="form.saletype" label="person">{{ tobonumberperson.title }}  <b style="color:red;">￥{{tobonumberperson.price}}</b></el-radio>-->
<!--                  </el-tooltip>-->

<!--                  自动化制图服务<span style="color: red"></span>-->

                </a-form-model-item>

                <a-form-item label="购买数量">

                  <el-input-number v-model="form.totalnum" :min="1" :max="10" label="描述文字"></el-input-number>
                </a-form-item>

                <a-form-model-item label="购买单位" prop="company">
                  <a-input
                      :disabled="true"
                      v-model="form.company"
                      placeholder="请输入购买单位全称"
                      style="width:70%"
                  />
                </a-form-model-item>

                <a-form-model-item label="信用代码" prop="yscode">
                  <a-input
                      :disabled="true"
                      v-model="form.yscode"
                      placeholder="请输入统一社会信用代码"
                      style="width:70%"
                  />
                </a-form-model-item>

                <a-form-model-item label="制图要求">
                  <b style="color: red;">图片大小请控制在1M以内，印章占图片尺寸要达到80%</b>
                </a-form-model-item>

                <a-form-model-item label="上传示例">
                    <el-image :src="shili" style="display:block;width: 120px;height: 120px"></el-image>
                </a-form-model-item>


              </a-col>
              <a-col :span="1"><div style="width: 100%;height: 1px;"></div></a-col>
              <a-col :span="11">
                <div>
<!--                  <a-form-model-item label="是否开票">-->
<!--                    <div style="display: flex; align-items: baseline">-->
<!--                      <el-radio v-model="form.drawer" :label="1" border>是</el-radio>-->
<!--                      <el-radio v-model="form.drawer" :label="2" border>否</el-radio>-->
<!--                    </div>-->
<!--                  </a-form-model-item>-->

                  <a-form-model-item label="电子邮箱" prop="email">
                    <a-input
                        :disabled="true"
                        v-model="form.email"
                        placeholder="请输入用于接收电子发票有效邮箱有效邮箱，请使用网易或QQ邮箱"
                        style="width:70%"
                    />
                  </a-form-model-item>

                  <a-form-model-item label="联系人" prop="name">
                    <a-input :disabled="true"  v-model="form.name" placeholder="请输入联系人姓名" style="width:70%"/>
                  </a-form-model-item>

                  <a-form-model-item label="手机号码" prop="phone">
                    <a-input
                        :disabled="true"
                        v-model="form.phone"
                        placeholder="请输入11位手机号码"
                        style="width:70%"
                    />
                  </a-form-model-item>

                  <a-form-item label="关于发票">
<!--                    <el-tooltip class="item" effect="dark" content="发票将在订单支付成功后3-5个工作日内发送到您填写的电子邮箱内。" placement="top">-->
                      <span style="color: red;cursor: pointer">发票将在订单支付成功后3-5个工作日内发送到您填写的电子邮箱内。</span>
<!--                    </el-tooltip>-->
                  </a-form-item>

<!--                  <a-form-item label="其他服务">-->
<!--                    <span style="color: #409EFF;cursor: pointer">-->
<!--                      <b style="margin:0 10px 0 5px;color:  #409EFF" @click="dinggou()">证书订购</b>-->
<!--                      <b style="color:  #409EFF" @click="nianfei()">年费服务</b>-->
<!--                    </span>-->
<!--                  </a-form-item>-->


<!--                  <a-form-model-item label="购方名称">-->
<!--                    <a-input v-model="form.company" disabled/>-->
<!--                  </a-form-model-item>-->

<!--                  <a-form-model-item label="购方税号">-->
<!--                    <a-input v-model="form.yscode" disabled/>-->
<!--                  </a-form-model-item>-->

<!--                  <a-form-model-item label="地址、电话" prop="address">-->
<!--                    <a-input-->
<!--                        v-model="form.address"-->
<!--                        placeholder="电子发票上的地址、电话"-->
<!--                    />-->
<!--                  </a-form-model-item>-->

<!--                  <a-form-model-item label="银行、账号" prop="bank">-->
<!--                    <a-input-->
<!--                        v-model="form.bank"-->
<!--                        placeholder="电子发票上的银行、账号"-->
<!--                    />-->
<!--                  </a-form-model-item>-->
                </div>
              </a-col>
            </a-row>
          </a-form-model>

          <div
              style="
              display: flex;
              flex-direction: row;
              justify-content: center;
              padding-top: 30px;
            "
          >
            <a-button v-if="companyinfostatus"  style="
                font-weight: bold;
                width: 200px;
                height: 40px;
                font-size: 15px;
              " type="danger" @click="login">登录后提交订单</a-button>

            <a-button v-if="!companyinfostatus" :disabled="disabledlook" style="
                font-weight: bold;
                width: 200px;
                height: 40px;
                font-size: 15px;
              " type="danger" @click="handleSubmit">
              提交订单
            </a-button>

          </div>

          <div style=" display: flex; flex-direction: row; justify-content: center; color:#132b75;line-height: 50px;cursor: pointer" @click="homepay">返回首页</div>


          <div
              id="bottomtoolbar"
              style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            "
          >
            <div id="sealintro">

              <div>
                本服务购买后<span style="color: red"
              >不可退款</span
              >，敬请理解！
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-card>

    <a-modal
        v-model="visiblemodd"
        title="流程说明"
        width="40%"
        @ok="handleOkmodd"
    >
      <p>
        <b>灌装流程说明：企业在此下单后，前往证书运维管理平台上自助抠账使用。</b>
      </p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </a-modal>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        title="自动化制图服务"
        width="30%"
    >
      <div id="successbox">
        <div class="infotip" style="line-height: 2">
          <p style="text-indent: 2em">
<!--            {{ configdata.province == '陕西' ? '陕西医保证书运维管理平台' : '证书在线服务平台' }}-->
<!--            感谢您订购智能图片处理服务。本服务一经出售，不接受退款申请。本次专属链接只能处理3次图片（仅支持椭圆、圆形、正方形的红色印章），处理3次图片后，本次链接自动失效。专属链接在订单支付成功后，自动发送到您的邮箱内，请前往邮箱内点击链接使用。-->
            感谢您订购智能图片处理服务。<b style="color: red">本服务一经出售，不接受退款申请</b>。本次专属链接只能处理<b style="color: red">3次</b>图片，处理<b style="color: red">3次</b>图片后，本次链接自动失效。专属链接在订单支付成功后，自动发送到您的邮箱内，请前往邮箱内点击链接使用。<b style="color: red">注：一次只能上传一张图片，并且图上只允许出现一个图片</b>
          </p>
        </div>
      </div>
      <template #footer>
        <a-button type="danger" @click="dialogVisible = false">确认</a-button>
      </template>
    </el-dialog>
    <!-- 二维码弹窗 -->
    <pay-test-modal
        ref="payTestModal"
        @closeBarCode="$refs.payTestBarCode.visible = false"
    ></pay-test-modal>

    <!-- 条码弹框 -->
    <pay-test-bar-code
        ref="payTestBarCode"
        @CodeAgainChange="testCodeChange"
        @barCodeValue="barCodeChange"
    ></pay-test-bar-code>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  company_servicetime,
  paysealorder,
  getsealprice,
  conf_list, Company_getInfo,
} from "@/api/manage"; // 接口
import PayTestModal from "./PayModal"; // 二维码对话框组件
import PayTestBarCode from "./PayBarCode"; // 条码对话框组件
import {Carousel} from "ant-design-vue";
import Footer from "@/components/footer/index.vue";
import Header from "@/components/heard/index.vue";
import shili from "@/assets/images/shili.png"
export default {
  name: "paytest",
  props: {},
  components: {PayTestModal, PayTestBarCode, Carousel, Header, Footer},
  data() {
    return {
      companyinfostatus:true,
      radio:'',
      shili:shili,
      totalnum: 1,
      projectname: "",
      sssvisiblesss: true,
      visiblemodd: false,
      dialogVisible: true,
      checked1: false,
      form: {
        drawer: 1,
        totalnum: 1,
        saletype:'auto',
        company:'',
        phone:'',
        yscode:'',
        email:'',
        name:'',
      },
      dialogStyle: {
        top: "40%",
      },
      rules: {
        company: [
          {required: true, message: "请输入购买单位全称", trigger: "blur"},
        ],
        yscode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        name: [
          {required: true, message: "请输入联系人姓名", trigger: "blur"},
        ],
        phone: [
          {required: true, message: "请输入11位手机号码", trigger: "blur"},
        ],
        email: [
          {
            required: true,
            message: "请输入用于接收电子发票有效邮箱",
            trigger: "blur",
          },
        ],
      },
      validatorRules: {
        phone: {
          //name与v-decorator中属性对应
          rules: [
            {required: true, message: "请输入手机号码!"},
            {pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码!"}, //此处配置正则表达式，手机号，可自己配置正则表达式
          ],
        },
        yscode: {
          //name与v-decorator中属性对应
          rules: [{required: true, message: "请输入统一社会信用代码!"}],
        },
        email: {
          //name与v-decorator中属性对应
          rules: [
            {required: true, message: "请输入正确的邮箱!"},
            {
              pattern: /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/,
              message: "请输入正确的邮箱!",
            }, //此处配置正则表达式，手机号，可自己配置正则表达式
          ],
        },
      },
      imgurl: require("@/assets/images/key.png"),
      imgbg: require("@/assets/images/topbg.jpeg"),
      mchAppList: [], // app列表
      appId: "2021003131636388", // 已选择的appId
      appPaywayList: ["ALI_QR"], // 商户app支持的支付方式
      currentWayCode: "ALI_QR", // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: "", // 支付参数
      mchOrderNo: "", // 模拟商户订单号
      authCode: "", // 条码的值
      companyyscode: "",
      paytestAmount: "0.01", // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: "接口调试", // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabled: false,
      disabledlook: false,
      visibletongzhi: false,
      visiblelook: false,
      drawer: 2,
      valiBtn: "同意条款",
      ModalText: "阅读协议，哈哈首科大厦大家安康",
      visible: false,
      visiblelx: false,
      companyname: "",
      confirmLoading: false,
      radioStyle: {
        cursor: "pointer",
        marginleft: "10px",
        height: "30px",
        lineHeight: "30px",
        color: "#132b75",
      },
      mpd: null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonumberperson:'',
      tobonum: null,
      number: {
        value: 11,
      },
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      configdata: {},
    };
  },
  created() {
    getsealprice({}).then((response) => {
      // console.log(response,'1++++++++++++')
      this.tobonumber = response.data;
      this.tobonumberperson = response.data1;
    });

    const date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    this.dates = date.getDate();
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata

    this.$nextTick(() => {
      var that = this
      var companyinfo = JSON.parse(localStorage.getItem('companyinfo'))
      console.log(that.companyinfo,'+++++++++')
      if(companyinfo != null) {
        that.companyinfostatus = false
        that.form.company = companyinfo.company
        that.form.phone = companyinfo.phonenumber
        that.form.yscode = companyinfo.yscode
        that.form.email = companyinfo.email
        that.form.name = companyinfo.nickName
        // that.form.setFieldsValue({
        //   company: companyinfo.company,
        //   phone: companyinfo.phonenumber,
        //   yscode: companyinfo.yscode,
        //   email: companyinfo.email,
        //   name: companyinfo.nickName,
        // })
      }
    })
  },

  mounted() {
    this.randomOrderNo();
  },

  methods: {
    login(){
      this.$router.push("/login")
    },
    dinggou(){
      this.$router.push("/index")
    },
    nianfei(){
      this.$router.push("/cost/index")
    },
    youxiang() {
      console.log("65565");
      window.open("https://qy.163.com/login/?from=ym");
    },
    homepay() {
      this.$router.push("/");
    },
    openyw() {
      window.open(this.configdata.certplatformurl, "_blank");
    },
    handleSubmitsks() {
      this.visiblelx = true;
    },
    handleOklx(e) {
      console.log(e);
      this.visiblelx = false;
    },

    handleCancesl() {
      this.sssvisiblesss = false;
    },
    handleOkmodd(e) {
      console.log(e);
      this.visiblemodd = false;
    },

    onChange1(e) {
      this.sendmethod = e.target.checked ? 1 : 2;
      this.mpd = e.target.checked;
      console.log(this.sendmethod);
      console.log(e.target.checked);
    },
    onChangeqw() {
      console.log("asad");
      this.disabledlook = false;
    },

    handleOk(e) {
      console.log("关闭2");
      this.visible = false;
      console.log(this.vshow);
      if (this.vshow) {
        this.visiblelook = true;
      }

      this.checked = true;
    },

    handleOklook() {
      this.disabledlook = false;
      this.visiblelook = false;
    },

    handleCancel(e) {
      console.log("关闭1");
      this.checked = false;
      this.visible = false;
      clearInterval(this.btnTime);
    },
    handleCancellook() {
      this.disabledlook = true;
      this.visiblelook = false;
    },

    onChangeq(e) {
      // console.log(e)
      console.log(`checked = ${e.target.checked}`);
    },

    onChange(a, b, c) {
      console.log(a, b, c);
    },

    //
    onChanges(value) {
      console.log("changed", value);
    },
    handleSubmits() {
      this.$router.push("/login");
    },
    handleSubmit(e) {
      var emailRegExp = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/
      this.$refs.form.validate((valid) => {
        if (valid) {

          console.log("Received values of form: ", this.form);
          // 判断是否为条码支付
          if (
              !this.$refs.payTestBarCode.getVisible() &&
              (this.currentWayCode === "WX_BAR" ||
                  this.currentWayCode === "ALI_BAR" ||
                  this.currentWayCode === "AUTO_BAR")
          ) {
            this.$refs.payTestBarCode.showModal();
            return;
          }
          const that = this;
          this.form.paymenthod = "ALI_QR";
          this.form.optype = "pc";
          this.form.paymenthod = "ALI_QR";

          if(emailRegExp.test(this.form.email)){
            paysealorder(this.form)
                .then((res) => {
                  console.log(res);
                  that.$refs.payTestModal.showModal(this.currentWayCode, res.data); // 打开弹窗
                  that.randomOrderNo(); // 刷新订单号
                })
                .catch(() => {
                  that.$refs.payTestBarCode.processCatch();
                  that.randomOrderNo(); // 刷新订单号
                });
            return false
          }else{
            this.$message({
              message: '请输入正确的邮箱!',
              type: 'warning'
            });
          }

        }
      })

    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === "male" ? "man" : "lady"}!`,
      });
    },
    // 支付板块是否展示
    payTestShow() {
      // 如果未选择appid，或者支付方式列表为0，则不显示支付体验板块
      if (this.appId === "" || this.appPaywayList.length === 0) {
        return false;
      } else {
        return true;
      }
    },

    changeCurrentWayCode(wayCode, currentPayDataType) {
      // 切换支付方式
      this.currentWayCode = wayCode;
      this.currentPayDataType = currentPayDataType;
    },

    // 变更 appId的事件
    changeAppId(value) {
      this.appPaywayListHandle(value); // 根据appId的值，动态显示支付方式
    },

    // 刷新订单号
    randomOrderNo() {
      this.mchOrderNo =
          "M" +
          new Date().getTime() +
          Math.floor(Math.random() * (9999 - 1000) + 1000);
    },

    // 获取条码的值
    barCodeChange(value) {
      this.authCode = value;
      this.immediatelyPay();
    },

    // 立即支付按钮
    immediatelyPay() {
      // 判断支付金额是否为0
      if (!this.paytestAmount || this.paytestAmount === 0.0) {
        return this.$message.error("请输入支付金额");
      }

      // 判断是否选择支付方式
      if (this.currentWayCode === "") {
        return this.$message.error("请选择支付方式");
      }

      // 请输入订单标题
      if (!this.orderTitle || this.orderTitle.length > 20) {
        return this.$message.error("请输入正确的订单标题[20字以内]");
      }

      // 判断是否为条码支付
      if (
          !this.$refs.payTestBarCode.getVisible() &&
          (this.currentWayCode === "WX_BAR" ||
              this.currentWayCode === "ALI_BAR" ||
              this.currentWayCode === "AUTO_BAR")
      ) {
        this.$refs.payTestBarCode.showModal();
        return;
      }

      const that = this;
      paysealorder({
        // jsapi 默认使用聚合二维码支付
        wayCode:
            this.currentWayCode === "WX_JSAPI" ||
            this.currentWayCode === "ALI_JSAPI"
                ? "QR_CASHIER"
                : this.currentWayCode, // 支付方式
        amount: this.paytestAmount, // 支付金额
        appId: this.appId, // appId
        mchOrderNo: this.mchOrderNo, // 订单编号
        payDataType: this.currentPayDataType, // 支付参数（二维码，条码）
        authCode: this.authCode,
        divisionMode: this.divisionMode,
        orderTitle: this.orderTitle,
      })
          .then((res) => {
            that.$refs.payTestModal.showModal(this.currentWayCode, res.data); // 打开弹窗
            that.randomOrderNo(); // 刷新订单号
          })
          .catch(() => {
            that.$refs.payTestBarCode.processCatch();
            that.randomOrderNo(); // 刷新订单号
          });
    },

    // 此处判断，微信，支付宝，聚合码，哪种支付方式一个都没配置，如果未配置，则不显示该板块，若等于-1 则表示不存在
    showTitle(parameterA) {
      if (this.appPaywayList.toString().indexOf(parameterA) === -1) {
        return false;
      } else {
        return true;
      }
    },
    // 聚合支付标题显示
    showQtTitle() {
      if (
          this.appPaywayList.toString().indexOf("WX") !== -1 ||
          this.appPaywayList.toString().indexOf("ALI") !== -1 ||
          this.appPaywayList.toString().indexOf("PP_PC") !== -1
      ) {
        return true;
      } else {
        return false;
      }
    },

    // 自定义金额输入框是否展示
    amountInputShow() {
      this.$nextTick(() => {
        // 输入框默认展示焦点
        this.$refs.amountInputFocus.focus();
      });
      this.amountInput = true;
      this.paytestAmount = "";
    },

    // 条码弹窗点击x或者蒙版关闭
    testCodeChange() {
      this.randomOrderNo(); // 刷新订单号
    },
  },
};
</script>

<style scoped>
@import "./seal.css";

body {
  background-color: #f0f2f5 !important;
}

/*html, body, #app, #root{background: #f5f5f5 !important;}*/

.ant-card,
.ant-card-bordered{
  background: transparent !important;
}

.paydemo,
.paydemo-type-content{
  background: transparent !important;
}

#box {
  background-image: url("../../assets/box_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}
/*}*/
b {
  color: #333;
}

#sealintro {
  text-align: center;
  margin-top: 20px;
  line-height: 2;
  font-size: 14px;
}

.wps {
  display: flex;
  justify-content: center;
  /*background: #132b75;*/
  height: 110px;
  line-height: 110px;
  /*padding: 25px 0;*/
  text-align: center;
  /*background: -webkit-radial-gradient(circle, #fff, #64d1dd, #e86a43);  */
  /*background:white; background-image: linear-gradient(90deg, rgba(200,0,0,.5) 50%, transparent 0), linear-gradient( rgba(200,0,0,.5) 50%, transparent 0); background-size: 30px 30px;*/
}

.boxw {
  display: block;
  width: 100px;
  height: 100px;
  font-size: 46px;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;
}

.biaoti {
  display: flex;
  flex-direction: row;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.shangpinbiaoti {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

.dingwei {
  width: 300px;
  height: 170px;
  position: absolute;
  top: -4px;
  right: 310px;
}


.dingweisb {
  /*width: 157px;*/

  position: absolute;
  top: 162px;
  left: 731px;
}

.position {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999 !important;
}

.position_cont {
  display: block;
  width: 500px;
  height: 200px;
  padding: 0 25px;
  box-sizing: border-box;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  margin-top: -125px;
  margin-left: -225px;
  z-index: 1000 !important;
}

.position_conttit {
  display: block;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_content {
  display: block;
  height: 100px;
  color: #f00;
  font-weight: bold;
  font-size: 14px;
  line-height: 70px;
  padding: 15px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.position_contbot {
  display: flex;
  justify-content: flex-end;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_contbot span {
  display: block;
  height: 35px;
  line-height: 20px;
  padding: 7px 25px;
  color: #fff;
  margin-top: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  background: #4278ff;
}
</style>
